import { createSlice } from '@reduxjs/toolkit';

export const defaultStudentListFilter = {
    dateOfEntry: "",
    dateOfExit: "",
    city: "",
    voucherType: "",
    status: "",
    sortBy: "",
    contactPerson: "",
    firstName: "",
    lastName: "",
    bgNumber: "",
    isActive: false,
    absences: [],
};

const initialState = {
    studentListFilter: { ...defaultStudentListFilter },
    allStudents: [],
    studentExaminations: [],
    studentContact: {},
    studentSickLeaves: [],
    studentInvoices: [],
    studentResultSheet: {},
    studentResultSheetPdfs: [],
    studentDischargeTerminationReport: [],
    studentCertificateAbsences: [],
    studentAttendancePdf: [],
    studentMissedAttendance: [],
    studentDocuments: {},
    studentFiles: [],
    studentReasonsAbsence: [],
    lecturerStudents: [],
    assessments: [],
    quizzes: {
        examAttempts: [],
        practiceAttempts: [],
    },
    speakingExams: [],
    videoLogs: [],
    loading: false,
    error: null,
    fridayExamAttempts: [],
    studentLogs: [],
};

const studentsSlice = createSlice({
    name: 'students',
    initialState,
    reducers: {
        setStudentListFilter: (state, action) => {
            state.studentListFilter = action.payload ? action.payload : defaultStudentListFilter;
        },
        setAllStudents: (state, action) => {
            state.allStudents = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentExaminations: (state, action) => {
            state.studentExaminations = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentContact: (state, action) => {
            state.studentContact = action.payload;
        },
        setStudentSickLeaves: (state, action) => {
            state.studentSickLeaves = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentInvoices: (state, action) => {
            state.studentInvoices = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentResultSheet: (state, action) => {
            state.studentResultSheet = action.payload;
        },
        setStudentResultSheetPdfs: (state, action) => {
            state.studentResultSheetPdfs = action.payload;
        },
        setStudentDischargeTerminationReport: (state, action) => {
            state.studentDischargeTerminationReport = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentCertificateAbsence: (state, action) => {
            state.studentCertificateAbsences = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentAttendancePdf: (state, action) => {
            state.studentAttendancePdf = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentMissedAttendance: (state, action) => {
            state.studentMissedAttendance = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentDocuments: (state, action) => {
            state.studentDocuments = action.payload;
        },
        setStudentFiles: (state, action) => {
            state.studentFiles = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentReasonsAbsence: (state, action) => {
            state.studentReasonsAbsence = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setLecturerStudents: (state, action) => {
            state.lecturerStudents = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setAssessments: (state, action) => {
            state.assessments = action.payload;
        },
        setQuizzes: (state, action) => {
            state.quizzes = action.payload;
        },
        setVideoLogs: (state, action) => {
            state.videoLogs = action.payload;
        },
        setSpeakingExams: (state, action) => {
            state.speakingExams = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setAbsences: (state, action) => {
            state.absences = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setFridayExamAttempts: (state, action) => {
            state.fridayExamAttempts = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setStudentLogs: (state, action) => {
            state.studentLogs = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const {
    setStudentListFilter,
    setInterimAssessmentPdf,
    setAssessments,
    setLecturerStudents,
    setAllStudents,
    setStudentExaminations,
    setStudentContact,
    setStudentSickLeaves,
    setStudentInvoices,
    setStudentResultSheet,
    setStudentResultSheetPdfs,
    setStudentDischargeTerminationReport,
    setStudentCertificateAbsence,
    setStudentAttendancePdf,
    setStudentMissedAttendance,
    setStudentDocuments,
    setStudentFiles,
    setStudentReasonsAbsence,
    setSpeakingExams,
    setQuizzes,
    setVideoLogs,
    setAbsences,
    setFridayExamAttempts,
    setStudentLogs,
} = studentsSlice.actions;

export default studentsSlice.reducer;